import loadable from '@loadable/component'

export default [
  {
    path: '/store',
    exact: true,
    component: loadable(
        () => import(/* webpackChunkName: "page-store" */ '~/pages/store')
    ),
  },
  {
    path: '/store/popUp',
    exact: true,
    component: loadable(
        () => import(/* webpackChunkName: "page-store-popUp" */ '~/pages/store/components/popUp')
    ),
  }
]
